export default {
  "Connect Wallet":"Connect Wallet",
  "Loading":"Loading...",
  "Purchase Quantity": "Purchase Quantity",
  "Total Amount": "Total Amount",
  "Payment Method": "Payment Method",
  "Fee": "Fee",
  "Purchase": "Buy",
  "Select Payment Method": "Select Payment Method",
  "Language Switch": "Language Switch",
  "Mall":"Mall",
  "STAR Purchase": "STAR Purchase",
  "Order Details": "Order Details",
  "My Orders": "My Orders",
  "Order Confirmation Page": "Order Confirmation Page",
  "Product Details": "Product Details",
  "Store Details": "Store Details",
  "Staking MUSE":"Staking MUSE",
  "My Stake":"My Stake",
  "Redeemable Time":"Redeemable Time",
  "Redeem":"Redeem",
  "Stake":"Stake",
  "How to Obtain MUSE":"How to Obtain MUSE",
  "Activity Rules":"Activity Rules",
  "Stake Amount":"Stake Amount",
  "Please Enter Amount":"Please Enter Amount",
  "Balance":"Balance",
  "Redeem Amount":"Redeem Amount",
  "Confirm":"Confirm",
  "Cancel":"Cancel",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.",
  "Rule1":"1. By staking MUSE, you can increase the voting weight of StarNest platform activities (refer to the corresponding activity description).",
  "Rule2":"2. The pledged MUSE can be redeemed at any time after the investment activity ends.",
  "Rule3":"3. By staking MUSE, you can also participate in platform governance and other activities.",
  "Rule4":"4. The final right of interpretation belongs to the StarNest platform.",
  "Staked":"Staked",
  "Redeemed":"Redeemed",
  "Payment":"Payment",
  "Next step":"Next step",
  "Amount":"Amount",
  "Copied":"Copied",
  "QRCodeTip":"Please scan the QR code or copy the address to pay the order amount. If the payment amount is insufficient, the order will fail and no refund will be made.",
  "Scan QR code to pay":"Scan QR code to pay",
  "DownloadTip":"Scan the QR code to download StarNest App and experience it now",
  "Save QR code":"Save QR code",
  "Minimum":"Minimum",
  "All":"All",
  "Failed to create order":"Failed to create order",
  "The order was created successfully and payment is being redirected":"The order was created successfully and payment is being redirected",
  "Payment details":"Payment details",
  "Address management":"Address management",
  "New address":"New address",
  "Delete address":"Delete address",
  "Are you sure you want to delete this address?":"Are you sure you want to delete this address?",
  "First name":"First name",
  "Last name":"Last name",
  "Please enter":"Please enter",
  "Phone":"Phone",
  "Country":"Country",
  "State/Province":"State/Province",
  "City":"City",
  "Address":"Address",
  "Zip code":"Zip code",
  "Email":"Email",
  "Save address":"Save address",
  "The address has been edited, do you want to save it?":"The address has been edited, do you want to save it?",
  "Return":"Return",
  "Save":"Save",
  "Waiting for payment":"Waiting for payment",
  "Please complete the payment within time as soon as possible":"Please complete the payment within {time} as soon as possible",
  "Expired":"Expired",
  "Order ID":"Order ID",
  "Order total":"Order total",
  "Order time":"Order time",
  "Payment method":"Payment method",
  "Billing address":"Billing address",
  "Switch address":"Switch address",
  "Pay":"Pay",
  "Deleted":"Deleted",
  "Create success":"Create success",
  "Update success":"Update success",
  "Insufficient balance":"Insufficient balance",
  "No address filled in yet":"No address filled in yet",
  "Choose country":"Choose country",
  "Please enter search keywords":"Please enter search keywords",
  "Payment successful":"Payment successful",
  "Please check the balance in your wallet":"Please check the balance in your wallet",
  "Finish":"Finish",
  "Payment failed":"Payment failed",
  "Please complete the payment in time in My Order-Waiting for Payment":"Please complete the payment in time in My Order-Waiting for Payment",
  "Verification": 'Please complete security verification',
  "Slide": 'Swipe right to complete verification',
  "Point": 'Please click',
  "Verify success": 'Verification succeeded',
  "Verify fail": 'verification failed',
  "Uploading":"Uploading",
  "Upload payment voucher":"Upload payment voucher",
  "Submission successful, please check the order later":"Submission successful, please check the order later",
  "Confirm submission":"Confirm submission",
  "Detail":"Detail",
  "Rate tip":"Depending on the payment method, there may be exchange rate differences in the fare, which is subject to the final payment amount.",
  "Please log in":"Please log in",
  "Insufficient product inventory":"Insufficient product inventory",
  "Showtime":"Showtime",
  "Ticket file":"Ticket file",
  "Sold out":"Sold out",
  "Limit tickets per order":"Limit {num} tickets per order",
  "Please select region":"Please select region",
  "Please fill in the correct email address":"Please fill in the correct email address",
  "Delivery method":"Delivery method",
  "E-ticket":"E-ticket",
  "Direct entry":"Direct entry",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher",
  "Contact person":"Contact person",
  "Name":"Name",
  "Please fill in the contact name":"Please fill in the contact name",
  "Region":"Region",
  "Please enter the mobile number":"Please enter the mobile number",
  "Please fill in the email":"Please fill in the email",
  "The ticket verification code will be sent to your email via":"The ticket verification code will be sent to your email via",
  "Details":"Details",
  "Submit order":"Submit order",
  "Price details":"Price details",
  "The actual discount amount is subject to the following single page":"The actual discount amount is subject to the following single page",
  "Product information":"Product information",
  "STAR deduction":"STAR deduction",
  "Credit Card":"Credit Card",
  "Payment Platform":"Payment Platform",
  "On-Chain Payment":"On-Chain Payment",
  "Other":"Other",
  "Ended":"Ended",
  "Countdown":"Countdown",
  "Please select the ticket file":"Please select the ticket file",
  "Insufficient commodity inventory":"Insufficient commodity inventory",
  "Please go to log in":"Please go to log in",
  "Integral Mall":"Integral Mall",
  "All Products":"All Products",
  "Integral Records":"Integral Records",
  "Transaction Details":"Transaction Details",
  "what": "What is MUSE?",
  "museIntro": "MUSE is an ARC20 token on Armonia Meta Chain. Total supply: 2.1B, 80% mined via ecosystem.",
  "museUse": "MUSE Utilities",
  "copyrightStaking": "Copyright Staking",
  "copyrightStaking1": "Stake MUSE in artists’ copyright NFTs (Metaverse AI, portraits, etc.) to share royalties.",
  "vote": "Voting",
  "vote1": "Stake MUSE for extra STAR NEST WAR voting rights.",
  "product": "Exclusive Purchases",
  "product1": "Buy limited NFTs, merch, tickets (early-bird/VIP).",
  "more": "More Features (Updated)",
  "more1": "GameFi: Licensed games use artists’ IPs; MUSE payments.",
  "more2": "Support Artists: Tip creators with MUSE.",
  "activity": "Exclusive Events",
  "activity1": "Access invites to private events.",
  "how": "How to Get MUSE?",
  "how1": "Join early private sales.",
  "how2": "Earn rewards via content creation.",
  "how3": "Get airdrops via events (tickets, shopping).",
  "how4": "Listen/Watch some Audition works and earn while enjoying",
  "Redeem now":"Redeem now",
  "Basic information":"Basic information",
}